import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getAllUserTypes } from '../../Constant.js'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import { write, utils } from 'xlsx'
import Loader from '../../common/Loader'
import moment from 'moment'
import Toggle from 'react-toggle'
import Select from 'react-select'

class Reports extends React.Component {
  state = {
    Data: [],
    start_date: '',
    end_date: moment().format('YYYY-MM-DD'),
    limit: 10,
    pageNumber: 0,
    totalPages: 0,
    disabled: false,
    keyword: '',
    dob_from: '',
    dob_to: '',
    device_type: '',
    gender: '',
    isLoading: false,
    user_type: 'user',

    without_booking: false,
    incomplete_user: false,
    deleted_user: false,

    country: '',
    country_list: [],
    countryData: null,
  }

  componentDidMount() {
    this.setState({
      start_date: moment().subtract(6, 'months').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
    })
    this.getCountries()
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true&all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data.map((itm) => ({
              label: `${itm.country_name_en}/${itm.country_name_ar}`,
              value: itm.country_short_name,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  newUser = async () => {
    this.setState({ Data: [], isLoading: true })
    let data = {
      createdAtFrom: this.state.start_date,
      createdAtTo: this.state.end_date,
      gender: this.state.gender,
      device_type: this.state.device_type,
      dob_from: this.state.dob_from,
      dob_to: this.state.dob_to,
      user_type: this.state.user_type,
      without_booking: this.state.without_booking,
      incomplete_user: this.state.incomplete_user,
      deleted_user: this.state.deleted_user,
      country: this.state.countryData?.value,
    }
    await axios
      .post(Constant.getAPI() + `/reports/new-user-report`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            Data: response?.data?.data?.data,
            isLoading: false,
          })
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })

        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value }, () => {
      if (
        (event?.target?.name == 'start_date' || event?.target?.name == 'end_date') &&
        this.checkDateDifference(this.state.start_date, this.state.end_date)
      ) {
        if (event?.target?.name == 'start_date') {
          this.setState({
            end_date: moment(this.state.start_date, 'YYYY-MM-DD').add(6, 'months').format('YYYY-MM-DD'),
          })
        } else {
          this.setState({
            start_date: moment(this.state.end_date, 'YYYY-MM-DD').subtract(6, 'months').format('YYYY-MM-DD'),
          })
        }
      }
    })

    if (event.target.name == 'user_type') {
      this.setState({
        without_booking: false,
        incomplete_user: false,
        deleted_user: false,
      })
    }
  }

  download = () => {
    let link = Constant.getImage() + this.state.reportUrl
    window.location.href = link
  }

  searchData = async () => {
    this.newUser()
  }

  clearFilter = async () => {
    this.setState({
      start_date: '',
      end_date: '',
      dob_to: '',
      dob_from: '',
      device_type: '',
      gender: '',
      Data: [],
      user_type: 'user',
    })
  }

  handleGender = (value) => {
    if (value == 'M') {
      return 'Male'
    } else if (value == 'F') {
      return 'Female'
    } else {
      return '--'
    }
  }

  checkDateDifference(date1, date2) {
    // Parse the dates using Moment.js
    const momentDate1 = moment(date1, 'YYYY-MM-DD')
    const momentDate2 = moment(date2, 'YYYY-MM-DD')

    // Calculate the difference in months
    const diffMonths = momentDate2.diff(momentDate1, 'months')
    // Compare the difference with 6
    if (diffMonths > 6) {
      return true
    } else {
      return false
    }
  }

  handleCountryChange = (event) => {
    this.setState({ countryData: event })
  }

  handleClear = () => {
    this.setState({ countryData: null })
  }

  render() {
    const columns = [
      {
        name: 'name',
        label: 'User Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value.trim() ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'phone',
        label: 'Phone',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'date',
        label: this.state.incomplete_user ? 'Created Date' : 'Registration Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'deleted_at',
        label: 'Deleted Date',
        options: {
          filter: true,
          sort: true,
          display: this.state.deleted_user,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'email',
        label: 'Email',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'dob',
        label: 'Date Of Birth',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'gender',
        label: 'Gender',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <div style={{ textTransform: 'uppercase' }}>{this.handleGender(value)}</div>
          },
        },
      },
      {
        name: 'device_type',
        label: 'Device Type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap', textTransform: 'uppercase' }}>
              {value == 'W' ? 'Website' : value || '--'}
            </div>
          ),
        },
      },
      {
        name: 'total_booking',
        label: 'Total Bookings',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Bookings`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            temp[columns[idx].name] = v
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()
        return false
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>User Report</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">User Report</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Created Start Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                max={moment().format('YYYY-MM-DD')}
                                id="date"
                                name="start_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.start_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Created End Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                max={moment().format('YYYY-MM-DD')}
                                id="date"
                                name="end_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.end_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Gender</label>
                            <div className="col-sm-9">
                              <select
                                name="gender"
                                className="form-control"
                                value={this.state.gender}
                                onChange={this.handleChange}
                              >
                                <option value={''}>Select Option</option>
                                <option value={'M'}>Male</option>
                                <option value={'F'}>Female</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Operating System</label>
                            <div className="col-sm-9">
                              <select
                                name="device_type"
                                className="form-control"
                                value={this.state.device_type}
                                onChange={this.handleChange}
                              >
                                <option value={''}>Select Option</option>
                                <option value={'iOS'}>iOS</option>
                                <option value={'Android'}>Android</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">DOB From</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                id="dob_from"
                                name="dob_from"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.dob_from}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">DOB To</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                id="dob_to"
                                name="dob_to"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.dob_to}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">User Type</label>
                            <div className="col-sm-9">
                              <select
                                name="user_type"
                                className="form-control"
                                value={this.state.user_type}
                                onChange={this.handleChange}
                              >
                                {getAllUserTypes().map((itm) => (
                                  <option value={itm.value}>{itm.label}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country</label>
                            <div className="col-sm-9">
                              <Select
                                name="countryData"
                                value={this.state.countryData}
                                onChange={this.handleCountryChange}
                                options={this.state.country_list}
                                isMulti={false}
                                isSearchable={true}
                                isClearable
                                onClear={this.handleClear}
                                placeholder="Select Options"
                                styles={{
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                    position: 'absolute',
                                    width: '100%',
                                  }),
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12"></div>
                        {this.state.user_type == 'user' && (
                          <>
                            <div className="col-4">
                              <div className="form-group row">
                                <label className="col-8 col-form-label">User Without Booking</label>
                                <div className="col-4">
                                  <Toggle
                                    className="f-right"
                                    checked={this.state.without_booking == true ? true : false}
                                    onChange={(value) => {
                                      this.setState({
                                        without_booking: value.target.checked,
                                        incomplete_user: false,
                                        deleted_user: false,
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label className="col-8 col-form-label">Incomplete Registered User only</label>
                                <div className="col-4">
                                  <Toggle
                                    className="f-right"
                                    checked={this.state.incomplete_user == true ? true : false}
                                    onChange={(value) => {
                                      this.setState({
                                        incomplete_user: value.target.checked,
                                        without_booking: false,
                                        deleted_user: false,
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label className="col-8 col-form-label">Deleted User only</label>
                                <div className="col-4">
                                  <Toggle
                                    className="f-right"
                                    checked={this.state.deleted_user == true ? true : false}
                                    onChange={(value) => {
                                      this.setState({
                                        deleted_user: value.target.checked,
                                        incomplete_user: false,
                                        without_booking: false,
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              className="col-6"
                              style={{ color: 'red' }}
                            >
                              You can get maximum 6 months rocords at a time
                            </div>
                            <div className="text-right col-10">
                              <button
                                style={{ width: 150 }}
                                onClick={this.clearFilter}
                                className="btn btn-inverse waves-effect"
                              >
                                Clear
                              </button>
                            </div>
                            <div className="text-right col-2">
                              {this.state.isSearching ? (
                                <button
                                  className="btn btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <button
                                  style={{ width: 150 }}
                                  onClick={this.searchData}
                                  className="btn btn-inverse waves-effect"
                                >
                                  Search
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-12">
                  <div className="card card-border-default">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'User Report'}
                          className="table-responsive"
                          data={this.state.Data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Reports
